import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSocket } from './net/socket';
import { connect, wireSocket } from './state/actions';
import './styles.css';

wireSocket(initSocket());
connect();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
